export enum ProductDuration {
  ONE = '1',
  TWO = '2',
  THREE = '3',
  FIVE = '5',
  FLEX = 'flex',
}
